import { FC, SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement> & {
  sx?: Record<string, unknown>
}

const PredictedPerformanceIcon: FC<Props> = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <mask id="path-1-inside-1_1170_3366" fill="white">
      <path d="M1 6H16V9H1V6Z" />
    </mask>
    <path d="M1 6H16V9H1V6Z" fill="#D375FF" />
    <path d="M1 9H16V3H1V9Z" fill="#D375FF" mask="url(#path-1-inside-1_1170_3366)" />
  </svg>
)

export default PredictedPerformanceIcon
